import React from "react";
import { Box, Typography, Button, Drawer, Stack } from "@mui/material";
import {
  colors,
  typography,
  spacing,
} from "../../../../../../../assets/styles/tokens";

export interface InsightItem {
  label: string;
  icon?: React.ReactNode;
  description: React.ReactNode;
}

interface InsightPopupProps {
  open: boolean;
  onClose: () => void;
  title: string;
  insights: InsightItem[];
}

const InsightPopup: React.FC<InsightPopupProps> = ({
  open,
  onClose,
  title,
  insights,
}) => {
  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "16px 16px 0 0",
          px: 2,
          py: 2,
          pb: 3,
          maxHeight: "90vh",
          bgcolor: colors.Base.White.$value,
        },
      }}
    >
      <Box
        sx={{
          width: 32,
          height: 4,
          bgcolor: colors.GrayLightMode[300].$value,
          borderRadius: 2,
          mx: "auto",
          mb: 1,
        }}
      />

      <Typography
        variant="h6"
        sx={{
          fontWeight: typography.Font_weight.Medium.$value,
          fontSize: typography.Size.Text.md.$value,
          color: colors.GrayLightMode[900].$value,
          textAlign: "center",
          mb: spacing.Spacing.xl.$value,
        }}
      >
        {title}
      </Typography>

      <Stack
        spacing={3}
        sx={{
          overflowY: "auto",
          mb: 3,
          "& > :not(style) ~ :not(style)": {
            marginTop: spacing.Spacing.lg.$value,
          },
        }}
      >
        {insights.map((insight, index) => (
          <Box key={index}>
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: typography.Font_weight.Medium.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                color: colors.GrayLightMode[700].$value,
                fontSize: typography.Size.Text.xs.$value,
                textTransform: "uppercase",
                mb: 1,
              }}
            >
              {insight.label}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "flex-start" }}>
              {insight.icon && (
                <Box sx={{ color: colors.GrayLightMode[600].$value }}>
                  {insight.icon}
                </Box>
              )}
              <Typography
                variant="body2"
                sx={{
                  color: colors.GrayLightMode[500].$value,
                  fontSize: typography.Size.Text.xs.$value,
                  lineHeight: typography.Line_height.text.xs.$value,
                  fontStyle: "italic",
                }}
              >
                {insight.description}
              </Typography>
            </Box>
          </Box>
        ))}
      </Stack>

      <Button
        fullWidth
        variant="contained"
        onClick={onClose}
        sx={{
          textTransform: "capitalize",
          boxShadow: "none !important",
          background: colors.Brand[600].$value,
          fontWeight: typography.Font_weight.Medium.$value,
          borderRadius: 2,
        }}
      >
        Close
      </Button>
    </Drawer>
  );
};

export default InsightPopup;
